<section class="vc-admin-customer-account">
  <header class="vc-admin-customer-account__header">
    <a routerLink="/administration/customers" class="vc-admin-customer-account__back">
      <i class="pi pi-arrow-left"></i>
      <span>{{ 'COMMON.BACK' | translate }}</span>
    </a>
    <h3>
      {{ 'ADMIN.CUSTOMERS.ACCOUNT.TITLE' | translate }}
      @if (account?.customer?.name) {
        <span class="vc-admin-customer-account__name">{{ account?.customer?.name }}</span>
      }
    </h3>
    <p>{{ 'ADMIN.CUSTOMERS.ACCOUNT.DESCRIPTION' | translate }}</p>
  </header>

  <nav class="vc-admin-customer-account__tabs">
    <button
      type="button"
      class="vc-admin-customer-account__tab"
      [class.is-active]="activeTab === 'fiscal'"
      (click)="activeTab = 'fiscal'"
    >
      {{ 'ADMIN.CUSTOMERS.ACCOUNT.TAB_FISCAL' | translate }}
    </button>
    <button
      type="button"
      class="vc-admin-customer-account__tab"
      [class.is-active]="activeTab === 'categories'"
      (click)="activeTab = 'categories'"
    >
      {{ 'ADMIN.CUSTOMERS.ACCOUNT.TAB_CATEGORIES' | translate }}
    </button>
    <button
      type="button"
      class="vc-admin-customer-account__tab"
      [class.is-active]="activeTab === 'modules'"
      (click)="activeTab = 'modules'"
    >
      {{ 'ADMIN.CUSTOMERS.ACCOUNT.TAB_MODULES' | translate }}
    </button>
    <button
      type="button"
      class="vc-admin-customer-account__tab"
      [class.is-active]="activeTab === 'pricing'"
      (click)="activeTab = 'pricing'"
    >
      {{ 'ADMIN.CUSTOMERS.ACCOUNT.TAB_PRICING' | translate }}
    </button>
    <button
      type="button"
      class="vc-admin-customer-account__tab"
      [class.is-active]="activeTab === 'storage'"
      (click)="activeTab = 'storage'"
    >
      {{ 'ADMIN.CUSTOMERS.ACCOUNT.TAB_STORAGE' | translate }}
    </button>
    <button
      type="button"
      class="vc-admin-customer-account__tab"
      [class.is-active]="activeTab === 'preview'"
      (click)="activeTab = 'preview'"
    >
      {{ 'ADMIN.CUSTOMERS.ACCOUNT.TAB_PREVIEW' | translate }}
    </button>
    <button
      type="button"
      class="vc-admin-customer-account__tab"
      [class.is-active]="activeTab === 'email'"
      (click)="activeTab = 'email'"
    >
      {{ 'ADMIN.EMAIL_ACCOUNTS.TAB' | translate }}
    </button>
  </nav>

  @if (loading) {
    <p class="vc-admin-customer-account__state">{{ 'COMMON.LOADING' | translate }}</p>
  } @else {
    @if (activeTab === 'fiscal') {
      <section class="vc-admin-customer-account__panel">
        <nav class="vc-admin-customer-account__subtabs">
          <button
            type="button"
            class="vc-admin-customer-account__subtab"
            [class.is-active]="activeFiscalSubTab === 'general'"
            (click)="activeFiscalSubTab = 'general'"
          >
            {{ 'ADMIN.CUSTOMERS.ACCOUNT.GENERAL_TITLE' | translate }}
          </button>
          <button
            type="button"
            class="vc-admin-customer-account__subtab"
            [class.is-active]="activeFiscalSubTab === 'fiscal'"
            (click)="activeFiscalSubTab = 'fiscal'"
          >
            {{ 'ADMIN.CUSTOMERS.ACCOUNT.FISCAL_TITLE' | translate }}
          </button>
          <button
            type="button"
            class="vc-admin-customer-account__subtab"
            [class.is-active]="activeFiscalSubTab === 'contract'"
            (click)="activeFiscalSubTab = 'contract'"
          >
            {{ 'ADMIN.CUSTOMERS.CONTRACT.TITLE' | translate }}
          </button>
        </nav>

        @if (activeFiscalSubTab === 'general') {
          <section>
            <h4>{{ 'ADMIN.CUSTOMERS.ACCOUNT.GENERAL_TITLE' | translate }}</h4>
            <div class="vc-admin-customer-account__grid">
              <label>
                <span>{{ 'COMMON.IDENTIFIER' | translate }}</span>
                <input pInputText [value]="account?.customer?.identifier || '-'" readonly />
              </label>
              <label>
                <span>{{ 'COMMON.NAME' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.name" />
              </label>
              <label>
                <span>{{ 'COMMON.EMAIL' | translate }}</span>
                <input pInputText type="email" [(ngModel)]="fiscalDraft.email" />
              </label>
              <label>
                <span>{{ 'COMMON.PHONE' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.phone" />
              </label>
              <label>
                <span>{{ 'COMMON.STATUS' | translate }}</span>
                <p-select
                  [options]="customerStatusOptions"
                  [(ngModel)]="fiscalDraft.status"
                  optionLabel="labelKey"
                  optionValue="value"
                  appendTo="body"
                  styleClass="w-full"
                >
                  <ng-template let-option pTemplate="item">
                    {{ option.labelKey | translate }}
                  </ng-template>
                  <ng-template let-option pTemplate="selectedItem">
                    {{ option?.labelKey ? (option.labelKey | translate) : ('COMMON.STATUS' | translate) }}
                  </ng-template>
                </p-select>
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.CONTACT_NAME' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.contact_name" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.CONTACT_EMAIL' | translate }}</span>
                <input pInputText type="email" [(ngModel)]="fiscalDraft.contact_email" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.CONTACT_PHONE' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.contact_phone" />
              </label>
            </div>
            <div class="vc-admin-customer-account__actions">
              <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="saveFiscal()">
                {{ 'COMMON.SAVE' | translate }}
              </button>
            </div>
          </section>
        }

        @if (activeFiscalSubTab === 'fiscal') {
          <section class="vc-admin-customer-account__contract">
            <h4>{{ 'ADMIN.CUSTOMERS.ACCOUNT.FISCAL_TITLE' | translate }}</h4>
            <div class="vc-admin-customer-account__grid">
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.LEGAL_NAME' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.legal_name" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.FISCAL_ID' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.fiscal_id" />
              </label>
              <label>
                <span>{{ 'COMMON.ADDRESS' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.address_line1" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.ADDRESS_2' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.address_line2" />
              </label>
              <label>
                <span>{{ 'COMMON.CITY' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.city" />
              </label>
              <label>
                <span>{{ 'COMMON.PROVINCE' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.province" />
              </label>
              <label>
                <span>{{ 'COMMON.POSTCODE' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.postal_code" />
              </label>
              <label>
                <span>{{ 'COMMON.COUNTRY' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.country_code" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.BILLING_EMAIL' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.billing_email" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.BILLING_CONTACT' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.billing_contact_name" />
              </label>
              <label class="vc-admin-customer-account__grid-full">
                <span>{{ 'ADMIN.CUSTOMERS.FISCAL.BILLING_NOTES' | translate }}</span>
                <input pInputText [(ngModel)]="fiscalDraft.billing_notes" />
              </label>
            </div>
            <div class="vc-admin-customer-account__actions">
              <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="saveFiscal()">
                {{ 'COMMON.SAVE' | translate }}
              </button>
            </div>
          </section>
        }

        @if (activeFiscalSubTab === 'contract') {
          <section class="vc-admin-customer-account__contract">
            <h4>{{ 'ADMIN.CUSTOMERS.CONTRACT.TITLE' | translate }}</h4>
            <div class="vc-admin-customer-account__grid">
              <label>
                <span>{{ 'COMMON.STATUS' | translate }}</span>
                <p-select
                  [options]="contractStatusOptions"
                  [(ngModel)]="contractDraft.status"
                  optionLabel="labelKey"
                  optionValue="value"
                  appendTo="body"
                  styleClass="w-full"
                >
                  <ng-template let-option pTemplate="item">
                    {{ option.labelKey | translate }}
                  </ng-template>
                  <ng-template let-option pTemplate="selectedItem">
                    {{ option?.labelKey ? (option.labelKey | translate) : ('COMMON.STATUS' | translate) }}
                  </ng-template>
                </p-select>
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.CONTRACT.STARTS_AT' | translate }}</span>
                <input type="date" [(ngModel)]="contractDraft.starts_at" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.CONTRACT.NEXT_BILLING' | translate }}</span>
                <input type="date" [(ngModel)]="contractDraft.next_billing_at" />
              </label>
              <label>
                <span>Ancla de ciclo</span>
                <input type="date" [(ngModel)]="contractDraft.cycle_anchor_at" />
              </label>
              <label>
                <span>Inicio próximo ciclo</span>
                <input type="date" [(ngModel)]="contractDraft.next_cycle_start_at" />
              </label>
              <label>
                <span>Zona horaria facturación</span>
                <input pInputText [(ngModel)]="contractDraft.billing_timezone" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.CONTRACT.ENDS_AT' | translate }}</span>
                <input type="date" [(ngModel)]="contractDraft.ends_at" />
              </label>
              <label>
                <span>{{ 'ADMIN.CUSTOMERS.CONTRACT.ACCOUNT_MANAGER' | translate }}</span>
                <input pInputText [(ngModel)]="contractDraft.account_manager" />
              </label>
              <label class="vc-admin-customer-account__grid-full">
                <span>{{ 'ADMIN.CUSTOMERS.CONTRACT.NOTES' | translate }}</span>
                <textarea pInputText rows="3" [(ngModel)]="contractDraft.contract_notes"></textarea>
              </label>
            </div>
            <div class="vc-admin-customer-account__actions">
              <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="saveContract()">
                {{ 'ADMIN.CUSTOMERS.CONTRACT.SAVE_ONLY' | translate }}
              </button>
            </div>
          </section>
        }
      </section>
    }

    @if (activeTab === 'categories') {
      <section class="vc-admin-customer-account__panel">
        <p class="vc-admin-customer-account__helper">
          {{ 'ADMIN.CUSTOMERS.ACCOUNT.CATEGORIES_HELP' | translate }}
        </p>
        <p-multiSelect
          [options]="categoryOptions"
          [(ngModel)]="categoriesDraft"
          optionLabel="displayName"
          optionValue="id"
          [filter]="true"
          [showToggleAll]="true"
          [placeholder]="'ADMIN.BUSINESS_CATEGORIES.SELECT' | translate"
          display="chip"
          styleClass="w-full"
        ></p-multiSelect>

        <div class="vc-admin-customer-account__actions">
          <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="saveCategories()">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </div>
      </section>
    }

    @if (activeTab === 'email') {
      <section class="vc-admin-customer-account__panel">
        <app-form-outbound-email-account
          [scope]="'customer'"
          titleKey="ADMIN.EMAIL_ACCOUNTS.CUSTOMER_TITLE"
          descriptionKey="ADMIN.EMAIL_ACCOUNTS.CUSTOMER_DESCRIPTION"
          [loadFn]="loadEmailAccount"
          [saveFn]="saveEmailAccount"
          [testFn]="testEmailAccount"
        ></app-form-outbound-email-account>
      </section>
    }

    @if (activeTab === 'modules') {
      <section class="vc-admin-customer-account__panel">
        <p-table [value]="modulesDraft" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'COMMON.MODULE' | translate }}</th>
              <th>{{ 'COMMON.ACTIVE' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>
                <div class="vc-admin-customer-account__module-name">
                  {{ getModuleLabel(row) }}
                  @if (isCoreModule(row)) {
                    <small>{{ 'ADMIN.CUSTOMERS.MODULES.CORE_LOCK_HINT' | translate }}</small>
                  }
                </div>
              </td>
              <td>
                <input type="checkbox" [(ngModel)]="row.enabled" [disabled]="isCoreModule(row)" />
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="vc-admin-customer-account__actions">
          <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="saveModules()">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </div>
      </section>
    }

    @if (activeTab === 'pricing') {
      <section class="vc-admin-customer-account__panel">
        <p-table [value]="pricingDraft" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.CONCEPT' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.GLOBAL' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.MODE_LABEL' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.DISCOUNT' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.LOCKED_BASE' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.APPLIED' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.DELTA' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ getConceptLabel(row) }}</td>
              <td>{{ row.global_price | number: '1.2-2' }} EUR</td>
              <td>
                <p-select
                  [options]="modeOptions"
                  [(ngModel)]="row.mode"
                  optionLabel="labelKey"
                  optionValue="value"
                  appendTo="body"
                  styleClass="w-full vc-admin-customer-account__mode-select"
                >
                  <ng-template let-option pTemplate="item">
                    {{ option.labelKey | translate }}
                  </ng-template>
                  <ng-template let-option pTemplate="selectedItem">
                    {{ option?.labelKey ? (option.labelKey | translate) : '' }}
                  </ng-template>
                </p-select>
              </td>
              <td>
                <p-inputNumber
                  [(ngModel)]="row.discount_percent"
                  mode="decimal"
                  [min]="0"
                  [max]="100"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                ></p-inputNumber>
              </td>
              <td>
                <p-inputNumber
                  [(ngModel)]="row.locked_base_price"
                  mode="decimal"
                  [min]="0"
                  [disabled]="row.mode !== 'CUSTOM_LOCKED'"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                ></p-inputNumber>
              </td>
              <td>{{ row.effective_price | number: '1.2-2' }} EUR</td>
              <td>{{ row.delta_vs_global | number: '1.2-2' }} EUR</td>
            </tr>
          </ng-template>
        </p-table>

        <div class="vc-admin-customer-account__actions">
          <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="savePricing()">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </div>
      </section>
    }

    @if (activeTab === 'storage') {
      <section class="vc-admin-customer-account__panel">
        <div
          class="vc-admin-customer-account__storage-summary"
          [attr.data-severity]="getStorageUsageSeverity()"
        >
          <div>
            <strong>{{ 'ADMIN.CUSTOMERS.ACCOUNT.STORAGE.USED' | translate }}</strong>
            <span>{{ storageDraft.used_mb | number: '1.0-2' }} MB</span>
          </div>
          <div>
            <strong>{{ 'ADMIN.CUSTOMERS.ACCOUNT.STORAGE.FREE' | translate }}</strong>
            <span>{{ getStorageFreeMb() | number: '1.0-2' }} MB</span>
          </div>
          <div>
            <strong>{{ 'ADMIN.CUSTOMERS.ACCOUNT.STORAGE.USAGE_PERCENT' | translate }}</strong>
            <span>{{ getStorageUsagePercent() | number: '1.0-2' }}%</span>
          </div>
        </div>

        <p class="vc-admin-customer-account__helper">
          {{ 'ADMIN.CUSTOMERS.ACCOUNT.STORAGE.HELP' | translate }}
        </p>

        <div class="vc-admin-customer-account__grid">
          <label>
            <span>{{ 'ADMIN.CUSTOMERS.ACCOUNT.STORAGE.QUOTA' | translate }}</span>
            <p-inputNumber
              [(ngModel)]="storageDraft.quota_mb"
              mode="decimal"
              [min]="1"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              suffix=" MB"
            ></p-inputNumber>
          </label>
          <label class="vc-admin-customer-account__toggle">
            <span>{{ 'ADMIN.CUSTOMERS.ACCOUNT.STORAGE.BLOCK_ON_LIMIT' | translate }}</span>
            <input type="checkbox" [(ngModel)]="storageDraft.block_on_limit" />
          </label>
        </div>

        <div class="vc-admin-customer-account__actions">
          <button pButton type="button" icon="pi pi-save" [disabled]="saving" (click)="saveStorage()">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </div>
      </section>
    }

    @if (activeTab === 'preview') {
      <section class="vc-admin-customer-account__panel">
        <div class="vc-admin-customer-account__preview-header">
          <label>
            <span>{{ 'ADMIN.CUSTOMERS.PREVIEW.MONTH' | translate }}</span>
            <input type="month" [(ngModel)]="month" />
          </label>
          <button pButton type="button" [text]="true" (click)="refreshPreview()">
            {{ 'COMMON.REFRESH' | translate }}
          </button>
        </div>

        <p-table [value]="preview?.lines || []" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.CONCEPT' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PREVIEW.QUANTITY' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.GLOBAL' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PRICING.APPLIED' | translate }}</th>
              <th>{{ 'ADMIN.CUSTOMERS.PREVIEW.SUBTOTAL' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-line>
            <tr>
              <td>{{ getConceptLabel(line) }}</td>
              <td>{{ line.quantity }}</td>
              <td>{{ line.global_price | number: '1.2-2' }} EUR</td>
              <td>{{ line.effective_price | number: '1.2-2' }} EUR</td>
              <td>{{ line.subtotal | number: '1.2-2' }} EUR</td>
            </tr>
          </ng-template>
        </p-table>

        <div class="vc-admin-customer-account__totals">
          <p>
            {{ 'ADMIN.CUSTOMERS.PREVIEW.TOTAL_GLOBAL' | translate }}:
            <strong>{{ preview?.totals?.total_monthly_global | number: '1.2-2' }} EUR</strong>
          </p>
          <p>
            {{ 'ADMIN.CUSTOMERS.PREVIEW.TOTAL_EFFECTIVE' | translate }}:
            <strong>{{ preview?.totals?.total_monthly_estimated | number: '1.2-2' }} EUR</strong>
          </p>
          <p>
            {{ 'ADMIN.CUSTOMERS.PREVIEW.TOTAL_DELTA' | translate }}:
            <strong>{{ preview?.totals?.total_monthly_delta | number: '1.2-2' }} EUR</strong>
          </p>
        </div>
      </section>
    }
  }
</section>
